var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-item" },
    [
      _c("div", { staticClass: "legend" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.date")))]),
        _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.type")))]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.publication")))
        ]),
        _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.print")))]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.comments")))
        ]),
        _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.shares")))]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.reactions")))
        ]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.engagement")))
        ])
      ]),
      _vm._l(_vm.posts, function(post) {
        return _c("div", { key: post.id, staticClass: "item" }, [
          _c("p", [_vm._v(_vm._s(_vm.getFormatDate(post.created_time)))]),
          _c("div", { staticClass: "type-content" }, [
            _c("div", { staticClass: "badge-type-post" }, [
              _vm._v(_vm._s(post.type == "snippet" ? "lien" : post.type))
            ])
          ]),
          _c("div", { staticClass: "publication" }, [
            _c("div", { staticClass: "picture" }, [
              post.type && post.type == "NATIVE_DOCUMENT"
                ? _c("i", { staticClass: "fa-regular fa-file-pdf" })
                : post.attachment_url
                ? _c("img", { attrs: { src: post.attachment_url } })
                : _c("i", { staticClass: "fa-regular fa-image-slash" })
            ]),
            _c("p", [_vm._v(_vm._s(post.message))])
          ]),
          _c("p", { staticClass: "impression number" }, [
            _vm._v(
              _vm._s("post_impressions" in post ? post.post_impressions : 0)
            )
          ]),
          _c("p", { staticClass: "comment number" }, [
            _vm._v(_vm._s("comments_count" in post ? post.comments_count : 0))
          ]),
          _c("p", { staticClass: "share number" }, [
            _vm._v(_vm._s("shares_count" in post ? post.shares_count : 0))
          ]),
          _c("p", { staticClass: "reaction number" }, [
            _vm._v(
              _vm._s(
                "post_reactions_sum" in post
                  ? post.post_reactions_sum
                  : "like_count" in post
                  ? post.like_count
                  : ""
              )
            )
          ]),
          _c("p", { staticClass: "engagement number" }, [
            _vm._v(
              _vm._s(
                "reach_engagement" in post
                  ? post.reach_engagement.toFixed(2) + "%"
                  : ""
              )
            )
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }